import { Signal } from '@angular/core';
import { apply, applyEach, disabled, required, schema, SchemaPathTree, validate } from '@angular/forms/signals';
import { IOrderSettingsFormModel, IProviderMethod, emailSchema } from '@dss-libs/portal/type/portal-types';
import { isSignerAuthenticationRequired } from './order-settings.utils';

export function createOrderSettingsSchema(signingMethods: Signal<readonly IProviderMethod[]>) {
  return schema((path: SchemaPathTree<IOrderSettingsFormModel>) => {
    required(path.name, { message: 'VALIDATION_MESSAGES.REQUIRED' });
    required(path.language, { message: 'VALIDATION_MESSAGES.REQUIRED' });
    required(path.expirationPeriod, { message: 'VALIDATION_MESSAGES.REQUIRED' });
    required(path.reminderInterval, { message: 'VALIDATION_MESSAGES.REQUIRED' });
    disabled(path.requireSignerAuthentication, {
      when: ({ valueOf }) => isSignerAuthenticationRequired(signingMethods(), valueOf(path.signingMethod)),
    });

    applyEach(path.notificationRecipients, (recipient) => {
      required(recipient.name, { message: 'VALIDATION_MESSAGES.REQUIRED' });
      apply(recipient.email, emailSchema);
      validate(recipient.email, ({ value, valueOf }) => {
        const email = value().trim().toLowerCase();
        if (!email) return undefined;
        const occurrences = valueOf(path.notificationRecipients).filter(
          (notificationRecipient) => notificationRecipient.email.trim().toLowerCase() === email
        ).length;
        return occurrences > 1 ? { kind: 'noDuplicate', message: 'VALIDATION_MESSAGES.DUPLICATE_EMAIL' } : undefined;
      });
    });
  });
}
